// import { emailValidation } from "../Utils/Utils";

import { emailValidation, urlValidation } from "../utils/GeneralUtils";

const validate = (values: any) => {
  const errors: {
    company: any;
    name: any;
    url: any;
    firstName: string | undefined;
    lastName: string | undefined;
    emailContact: string | undefined;
    newPassword: string | undefined;
    confirmNewPassword: string | undefined;
    time: string | undefined;
    recipient: any;
    subject: string | undefined;
    message: string | undefined;
    zipcode: string | undefined;
    assignTo: string | undefined;
  } = {
    company: undefined,
    firstName: undefined,
    lastName: undefined,
    name: undefined,
    url: undefined,
    emailContact: undefined,
    newPassword: undefined,
    confirmNewPassword: undefined,
    time: undefined,
    recipient: undefined,
    subject: undefined,
    message: undefined,
    zipcode: undefined,
    assignTo: undefined,
  };

  if (!values.company) {
    errors.company = "Required";
  }
  if (!values.name) {
    errors.name = "Required";
  } else if (values.name.length <= 1) {
    errors.name = "Enter valid name";
  }
  if (!values.url) {
    errors.url = "Required";
  }
  // if (!emailValidation().test(values.url)) {
  //   errors.url = "Enter valid URL (starts with https)";
  // }
  if(!urlValidation().test(values.url)) {
    errors.url="Enter valid URL (starts with http)"
  }
  if (!values.emailContact) {
    errors.emailContact = "Required";
  } 

  if (!values.newPassword) {
    errors.newPassword = "password required";
  }
  if (!values.firstName) {
    errors.firstName = "Required";
  }

  if (!values.lastName) {
    errors.lastName = "Required";
  }
  if (!values.confirmNewPassword) {
    errors.confirmNewPassword = "confirm password required";
  }
  if (values.zipcode) {
    if (values?.zipcode?.length < 5) {
      errors.zipcode = "At least 5 digits required";
    }
  }

  if (values.newPassword != values.confirmNewPassword) {
    errors.confirmNewPassword = "Password not matched";
  }

  if (!values.time) {
    errors.time = "Please select a slot";
  }
  if (!values?.recipient) {
    errors.recipient = "Please Enter the Recipient";
  }
  if (!values?.subject) {
    errors.subject = "Please Enter the Subject";
  }
  if (!values?.message && !values.file) {
    errors.message = "Please Enter the Message / Attachment";
  }
  if (!values.assignTo) {
    errors.assignTo = "Required";
  } 


  return errors;
};

export default validate;
